var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trusted",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.001,
    height: 65,
    viewBox: "0 0 65.001 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M63.884,45.389l-7.3-7.3a26.658,26.658,0,1,0-48.168,0l-7.3,7.3A3.809,3.809,0,0,0,2.7,51.727l8.108,2.463L13.275,62.3a3.809,3.809,0,0,0,6.337,1.587L30.268,53.229a26.926,26.926,0,0,0,4.464,0L45.388,63.885A3.81,3.81,0,0,0,51.726,62.3l2.463-8.108L62.3,51.727a3.809,3.809,0,0,0,1.587-6.337ZM16.92,61.191l-2.464-8.108a3.8,3.8,0,0,0-2.536-2.538L3.811,48.082l6.563-6.563a26.752,26.752,0,0,0,15.3,10.917ZM13.126,38.766C3.558,23.53,14.69,3.81,32.5,3.81c17.954,0,28.856,19.856,19.374,34.956a22.847,22.847,0,0,1-38.748,0ZM53.082,50.545a3.8,3.8,0,0,0-2.538,2.538l-2.463,8.108-8.756-8.756a26.753,26.753,0,0,0,15.3-10.917l6.563,6.563Z",
    transform: "translate(0 -0.002)",
    fill: "#2e3d62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M124.953,60A19.043,19.043,0,1,0,144,79.044,19.065,19.065,0,0,0,124.953,60Zm-10.27,30.283c-10.283-9.386-3.518-26.474,10.27-26.474a15.231,15.231,0,1,1-10.27,26.474Z",
    transform: "translate(-92.453 -52.384)",
    fill: "#2e3d62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M201.147,166.85l-8.394,6.23-2.908-3.1a1.9,1.9,0,1,0-2.777,2.606l4.069,4.335a1.9,1.9,0,0,0,2.523.226l9.756-7.242a1.9,1.9,0,0,0-2.27-3.058Z",
    transform: "translate(-162.869 -145.341)",
    fill: "#2e3d62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/T2.ddb778fa78b5bb90702e9ebefd050991.svg";
export { ForwardRef as ReactComponent };